import styled, { css } from 'styled-components'
import { TTooltip, TBoxSelect, TLabelSelect, TContainerSelect } from './types'

// Estilos
export const Tooltip = styled.div<TTooltip>`
    left: ${({ gs, tLeft }) => tLeft || gs?.tooltip?.left};
    color: ${({ gs, tColor }) => tColor || gs?.tooltip?.color};
    border: ${({ gs, tBorder }) => tBorder || gs?.tooltip?.border};
    z-index: ${({ gs, tZIndex }) => tZIndex || gs?.tooltip?.zIndex};
    display: ${({ gs, tDisplay }) => tDisplay || gs?.tooltip?.display};
    padding: ${({ gs, tPadding }) => tPadding || gs?.tooltip?.padding};
    ${({ gs, tTop }) => (tTop || gs?.tooltip?.top) && css`top: ${tTop || gs?.tooltip?.top};`}
    font-size: ${({ gs, tFontSize }) => tFontSize || gs?.tooltip?.fontSize};
    position: ${({ gs, tPosition }) => tPosition || gs?.tooltip?.position};
    box-shadow: ${({ gs, tBoxShadow }) => tBoxShadow || gs?.tooltip?.boxShadow};
    font-family: ${({ gs, tFontFamily }) => tFontFamily || gs?.tooltip?.fontFamily};
    ${({ gs, tBottom }) => (tBottom || gs?.tooltip?.bottom) && css`bottom: ${tBottom || gs?.tooltip?.bottom};`}
    border-radius: ${({ gs, tBorderRadius }) => tBorderRadius || gs?.tooltip?.borderRadius};
    background-color: ${({ gs, tBackgroundColor }) => tBackgroundColor || gs?.tooltip?.backgroundColor};
    &::after, &::before {
        left: ${({ gs, tLeftAfterBefore }) => tLeftAfterBefore || gs?.tooltip?.leftAfterBefore};
        position: ${({ gs, tPositionAfterBefore }) => tPositionAfterBefore || gs?.tooltip?.position};
        border: ${({ gs, tBorderAfterBefore }) => tBorderAfterBefore || gs?.tooltip?.borderAfterBefore};
        ${({ gs, tTopAfterBefore }) => (tTopAfterBefore || gs?.tooltip?.topAfterBefore) && css`top: ${tTopAfterBefore || gs?.tooltip?.topAfterBefore};`}
        pointer-events: ${({ gs, tPointerEventsAfterBefore }) => tPointerEventsAfterBefore || gs?.tooltip?.pointerEventsAfterBefore};
        ${({ gs, tBottomAfterBefore }) => (tBottomAfterBefore || gs?.tooltip?.bottomAfterBefore) && css`bottom: ${tBottomAfterBefore || gs?.tooltip?.bottomAfterBefore};`}
        ${({ gs, tContentAfterBefore }) => (tContentAfterBefore || gs?.tooltip?.contentAfterBefore) && css`content: ${tContentAfterBefore || gs?.tooltip?.contentAfterBefore};`}
    }
    ${({ tStyles }) => tStyles};
    ${({ gs }) => gs?.tooltip?.styles};
`
export const Container = styled.div<TContainerSelect>`
    width: ${({ gs, cWidth }) => cWidth || gs?.container?.width};
    display: ${({ gs, cDisplay }) => cDisplay || gs?.container?.display};
    position: ${({ gs, cPosition }) => cPosition || gs?.container?.position};
    flex-direction: ${({ gs, cFlexDirection }) => cFlexDirection || gs?.container?.flexDirection};
    ${({ gs, cMargin }) => (cMargin || gs?.container?.margin) && css`margin: ${cMargin || gs?.container?.margin};`}
    ${({ gs, cMinWidth }) => (cMinWidth || gs?.container?.minWidth) && css`min-width: ${cMinWidth || gs?.container?.minWidth};`}
    ${({ gs, cMaxWidth }) => (cMaxWidth || gs?.container?.maxWidth) && css`min-width: ${cMaxWidth || gs?.container?.maxWidth};`}
    &:hover > ${Tooltip} { display: ${({ gs, cHoverDisplayTooltip }) => cHoverDisplayTooltip || gs?.container?.hoverDisplayTooltip}; }
    ${({ mediaTable, gs, maxWidthTable, widthTable }) => (mediaTable || gs?.container?.mediaTable) && css`
        @media only screen and (max-width: ${ maxWidthTable || gs?.container?.maxWidthTable}) {
            width: ${ widthTable || gs?.container?.widthTable};
        }
    ` }
    ${({ mediaPhone, gs, widthPhone, maxWidthPhone }) => (mediaPhone || gs?.container?.mediaPhone) && css`
        @media only screen and (max-width: ${maxWidthPhone || gs?.container?.maxWidthPhone}) {
            width: ${ widthPhone || gs?.container?.widthPhone};
        }
    ` }
    ${({ cStyles }) => cStyles};
    ${({ gs }) => gs?.container?.styles};
`
export const LabelSelect = styled.span<TLabelSelect>`
    border: ${({ gs, lBorder }) => lBorder || gs?.label?.border};
    margin: ${({ gs, lMargin }) => lMargin || gs?.label?.margin};
    padding: ${({ gs, lPadding }) => lPadding || gs?.label?.padding};
    font-size: ${({ gs, lFontSize }) => lFontSize || gs?.label?.fontSize};
    overflow: ${({ gs, lOverflow }) => lOverflow || gs?.label?.overflow};
    text-align: ${({ gs, lTextAlign }) => lTextAlign || gs?.label?.textAlign};
    white-space: ${({ gs, lWhiteSpace }) => lWhiteSpace || gs?.label?.whiteSpace};
    font-family: ${({ gs, lFontFamily }) => lFontFamily || gs?.label?.fontFamily};
    text-overflow: ${({ gs, lTextOverflow }) => lTextOverflow || gs?.label?.textOverflow};
    &:hover ~ ${Tooltip} { display: ${({ gs, lHoverDisplayTooltip }) => lHoverDisplayTooltip || gs?.label?.hoverDisplayTooltip}; }
    color: ${({ gs, val, lColor, error, loading, lErrorColor, lNotValueColor }) => error ? (lErrorColor || gs?.label?.colorError) : ((val || loading) ? (lColor || gs?.label?.color) : (lNotValueColor || gs?.label?.colorNotValue))};
    &:hover::after {
        opacity: ${({ lActiveTitle, valLabel, axis }) => (lActiveTitle && valLabel && axis?.y && axis?.x) ? 1 : 0};
        visibility: visible;
    }
    &::after {
        top: ${({ axis }) => axis?.y || -1000}px;
        left: ${({ axis }) => axis?.x || -1000}px;
        color: ${({ tlColor, gs }) => tlColor || gs?.tooltipLabel?.color};
        z-index: ${({ tlZIndex, gs }) => tlZIndex || gs?.tooltipLabel?.zIndex};
        opacity: ${({ tlOpacity, gs }) => tlOpacity || gs?.tooltipLabel?.opacity};
        padding: ${({ tlPadding, gs }) => tlPadding || gs?.tooltipLabel?.padding};
        max-width: ${({ tlMaxWidth, gs }) => tlMaxWidth || gs?.tooltipLabel?.maxWidth};
        position: ${({ tlPosition, gs }) => tlPosition || gs?.tooltipLabel?.position};
        font-size: ${({ tlFontSize, gs }) => tlFontSize || gs?.tooltipLabel?.fontSize};
        max-height: ${({ tlMaxHeight, gs }) => tlMaxHeight || gs?.tooltipLabel?.maxHeight};
        visibility: ${({ tlVisibility, gs }) => tlVisibility || gs?.tooltipLabel?.visibility};
        font-family: ${({ tlFontFamily, gs }) => tlFontFamily || gs?.tooltipLabel?.fontFamily};
        border-radius: ${({ tlBorderRadius, gs }) => tlBorderRadius || gs?.tooltipLabel?.borderRadius};
        background-color: ${({ tlBackgroundColor, gs }) => tlBackgroundColor || gs?.tooltipLabel?.backgroundColor};
        content: ${({ lActiveTitle, valLabel, axis }) => `'${(lActiveTitle && valLabel && axis?.y && axis?.x) ? valLabel : ''}'`};
        ${({ tlOverflow, gs }) => (tlOverflow || gs?.tooltipLabel?.overflow) && css`overflow: ${tlOverflow || gs?.tooltipLabel?.overflow};`}
        ${({ tlWhiteSpace, gs }) => (tlWhiteSpace || gs?.tooltipLabel?.whiteSpace) && css`white-space: ${tlWhiteSpace || gs?.tooltipLabel?.whiteSpace};`}
        ${({ tlTextOverflow, gs }) => (tlTextOverflow || gs?.tooltipLabel?.textOverflow) && css`text-overflow: ${tlTextOverflow || gs?.tooltipLabel?.textOverflow};`}
        ${({ tlStyles }) => tlStyles};
        ${({ gs }) => gs?.tooltipLabel?.styles};
    }
    ${({ lStyles }) => lStyles};
    ${({ gs }) => gs?.label?.styles};
`
export const BoxSelect = styled.div<TBoxSelect>`
    &:hover::after {
        opacity: ${({ sActiveTitle, val, axis }) => (sActiveTitle && val && axis?.y && axis?.x) ? 1 : 0};
        visibility: visible;
    }
    &::after {
        top: ${({ axis }) => axis?.y || -1000}px;
        left: ${({ axis }) => axis?.x || -1000}px;
        color: ${({ tiColor, gs }) => tiColor || gs?.tooltipSelect?.color};
        z-index: ${({ tiZIndex, gs }) => tiZIndex || gs?.tooltipSelect?.zIndex};
        opacity: ${({ tiOpacity, gs }) => tiOpacity || gs?.tooltipSelect?.opacity};
        padding: ${({ tiPadding, gs }) => tiPadding || gs?.tooltipSelect?.padding};
        position: ${({ tiPosition, gs }) => tiPosition || gs?.tooltipSelect?.position};
        max-width: ${({ tiMaxWidth, gs }) => tiMaxWidth || gs?.tooltipSelect?.maxWidth};
        font-size: ${({ tiFontSize, gs }) => tiFontSize || gs?.tooltipSelect?.fontSize};
        max-height: ${({ tiMaxHeight, gs }) => tiMaxHeight || gs?.tooltipSelect?.maxHeight};
        visibility: ${({ tiVisibility, gs }) => tiVisibility || gs?.tooltipSelect?.visibility};
        font-family: ${({ tiFontFamily, gs }) => tiFontFamily || gs?.tooltipSelect?.fontFamily};
        border-radius: ${({ tiBorderRadius, gs }) => tiBorderRadius || gs?.tooltipSelect?.borderRadius};
        content: ${({ sActiveTitle, val, axis }) => `'${(sActiveTitle && val && axis?.y && axis?.x) ? val : ''}'`};
        background-color: ${({ tiBackgroundColor, gs }) => tiBackgroundColor || gs?.tooltipSelect?.backgroundColor};
        ${({ tiOverflow, gs }) => (tiOverflow || gs?.tooltipSelect?.overflow) && css`overflow: ${tiOverflow || gs?.tooltipSelect?.overflow};`}
        ${({ tiWhiteSpace, gs }) => (tiWhiteSpace || gs?.tooltipSelect?.whiteSpace) && css`white-space: ${tiWhiteSpace || gs?.tooltipSelect?.whiteSpace};`}
        ${({ tiTextOverflow, gs }) => (tiTextOverflow || gs?.tooltipSelect?.textOverflow) && css`text-overflow: ${tiTextOverflow || gs?.tooltipSelect?.textOverflow};`}
        ${({ tiStyles }) => tiStyles};
        ${({ gs }) => gs?.tooltipSelect?.styles};
    }
    ${({ bStyles }) => bStyles};
    ${({ gs }) => gs?.boxSelect?.styles};
`